import React from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

interface WarningDialogProps {
  dialogOpen: boolean;
  bodyText?: string;
  title: string;
  affirmText: string;
  action: any;
  cancelAction: () => void;
  isCancelNeeded: boolean;
  isLoading?: boolean;
  disabled?: boolean;
}

const WarningDialog = (props: React.PropsWithChildren<WarningDialogProps>) => {
  return (
    <Dialog
      open={props.dialogOpen}
      id="status-alert-dialog"
      onClose={props.cancelAction}
      aria-labelledby="alert-dialog-title"
    >
      <DialogTitle id="alert-dialog-title" variant="h4">
        {props.title}
      </DialogTitle>

      <DialogContent>
        {props.bodyText && (
          <Typography>
            {props.bodyText.split('\n').map((i, key) => {
              return (
                <span key={key}>
                  {i}
                  <br />
                </span>
              );
            })}
          </Typography>
        )}
        {props.children}
      </DialogContent>
      <DialogActions style={{ padding: '5%' }}>
        {props.isCancelNeeded && (
          <Button
            onClick={props.cancelAction}
            autoFocus
            color="primary"
            data-testid="dialog-cancel-button"
            id="dialog-cancel-button"
            disabled={props.isLoading}
          >
            Cancel
          </Button>
        )}
        <LoadingButton
          onClick={props.action}
          color="primary"
          variant="contained"
          loading={props.isLoading}
          data-testid="dialog-confirm-button"
          id="dialog-confirm-button"
          disabled={props.isLoading}
        >
          {props.affirmText}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default WarningDialog;
